import { useDeleteAccountMutation, useGetAccountWithDetailQuery, useGetUserQuery } from '~/types/types';
export default defineComponent({
  props: {
    id: {
      type: String,
      required: true
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var inputConfirm = ref('');
    var modal = ref(false);
    var _useGetAccountWithDet = useGetAccountWithDetailQuery({
        id: props.id
      }, computed(function () {
        return {
          enabled: modal.value
        };
      })),
      result = _useGetAccountWithDet.result,
      loading = _useGetAccountWithDet.loading;
    var _useDeleteAccountMuta = useDeleteAccountMutation(),
      deleteAccount = _useDeleteAccountMuta.mutate,
      onDone = _useDeleteAccountMuta.onDone,
      deleteLoading = _useDeleteAccountMuta.loading;
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var user = computed(function () {
      var _userResult$value;
      return ((_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser) || {
        locale: 'en-US',
        isAdmin: false
      };
    });
    onDone(function () {
      emit('done');
    });
    return {
      loading: loading,
      modal: modal,
      deleteLoading: deleteLoading,
      user: user,
      toDeleteAccount: computed(function () {
        var _result$value;
        return ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getAccount) || {};
      }),
      deleteAccount: deleteAccount,
      inputConfirm: inputConfirm
    };
  }
});